import type { Filter_FacetsFragment } from '@generated/graphql'

import { renameFilteredFacetsLabel } from '../utils/renameFilteredFacetsLabel'
import type { FilterFacetsProps } from '../types/userFilterFacetsProps'
import { validatedFacetsByPage } from '../utils/validatedFacetsByPage'

function handleCategoryFilter(filteredFacets?: Filter_FacetsFragment[]) {
  const facets =
    filteredFacets?.filter(({ key }) => key?.indexOf('category') === -1) ?? []

  const listFacets = ['category-1', 'category-2', 'category-3', 'category-4']
  const facetsFilter = filteredFacets?.filter(
    (facet) =>
      listFacets.includes(facet?.key) &&
      facet?.__typename === 'StoreFacetBoolean' &&
      facet?.values?.length > 1
  )

  const filterFacetsSelected = facetsFilter?.find((_facet, indexSelected) => {
    return !facetsFilter
      ?.slice(indexSelected)
      ?.filter(
        (item) =>
          item?.__typename === 'StoreFacetBoolean' &&
          item?.values?.some((value) => value?.selected)
      )?.length
  })

  if (filterFacetsSelected) {
    facets.unshift(filterFacetsSelected)
  }

  const renamedFilter = renameFilteredFacetsLabel(facets)

  if (renamedFilter) {
    return [...renamedFilter]
  }

  return []
}

export default function useFilterFacets({
  facets,
  filterByUrl,
  base,
}: FilterFacetsProps) {
  let filteredFacets = facets?.filter(
    (facet) =>
      facet?.key?.toLocaleLowerCase() !== 'productclusterids' &&
      facet?.key?.toLocaleLowerCase() !== 'productclusternames'
  )

  filteredFacets = validatedFacetsByPage({ base, filteredFacets })

  if (!filterByUrl) {
    return renameFilteredFacetsLabel(filteredFacets)
  }

  return handleCategoryFilter(filteredFacets)
}
